import React from "react";
import { FormattedMessage } from "react-intl";

import EmptyData from "../EmptyData";
import ProjectCard from "./ProjectCard";

import "./style.scss";

const ProjectsList = ({ projects, projectStatuses, isInitiatives = false }) => {
  if (!projects?.length > 0)
    return <EmptyData title={<FormattedMessage id="no-data" />} />;

  return (
    <div className="cards-wrapper">
      {projects.map((item) => (
        <ProjectCard data={item} key={item?.ID} statuses={projectStatuses} isInitiatives={isInitiatives}/>
      ))}
    </div>
  );
};

export default ProjectsList;
